{
	"title": "Rapport de gestion",
	"exportToExcel": "Exporter vers Excel",
	"exportToPDF": "Exporter en PDF",
	"exportButton": "Exporter DRE",
	"excelTitles": {
		"incomeList": "Revenus",
		"costsList": "Coûts",
		"expensesList": "Dépenses"
	},
	"periodSelect": {
		"fifteen": "15 derniers jours",
		"thirty": "30 derniers jours",
		"sixty": "60 derniers jours",
		"selectPeriod": "Sélectionner une période"
	},
	"description": "Le DRE de gestion permet d'analyser la santé financière et les résultats des profits ou des pertes d'une opération pour équilibrer les dépenses et augmenter les revenus, en optimisant les coûts et en générant des bénéfices.",
	"periodDescription": "Affichage des valeurs consolidées de {{since}} à {{until}}",
	"tabs": {
		"summary": "Résumé",
		"overview": "Aperçu"
	},
	"period": "Période",
	"applyDate": "Appliquer la date",
	"table": {
		"level": "Niveau",
		"income": "Revenus",
		"costs": "Coûts",
		"expenses": "Dépenses",
		"description": "Description",
		"total": "Totale",
		"contribution": "Marge de contribution",
		"noData": "Aucune donnée",
		"summaries": {
			"totalIncome": "Totale revenus",
			"totalCosts": "Totale coûts",
			"totalExpenses": "Totale dépenses",
			"totalPeriod": "Totale pour la peériode"
		}
	}
}
